import {createBrowserRouter} from 'react-router';
import {RouterProvider} from 'react-router/dom';

import {appRoutes} from './index';

const router = createBrowserRouter(appRoutes);

export const Router = () => <RouterProvider router={router} />;
